<template>
    <tr>
        <td>{{ stock.brandName }}</td>
        <td>{{ stock.collectionName }}</td>
        <td>{{ stock.productName }}</td>
        <td :data-tooltip="stock.codeStorage">{{ cutCode }}</td>
        <td>{{ openedStatus }}</td>
        <td>{{ loanedStatus }}</td>
        <td>{{ getName(stock.typePackId, 'type_pack_id', 'type_packs') }}</td>
        <td>{{ getName(stock.packageCapacityId, 'package_capacity_id', 'package_capacities') }}</td>
        <td :style="statusStyle">{{ labels[stock.status] }}</td>
        <td nowrap>
            <span style="overflow: visible; position: relative; width: 110px;">
                <div class="dropdown" style="display: inline-block;">
                    <a href="#" class="btn btn-success btn-elevate btn-sm btn-circle btn-icon" data-toggle="dropdown">
                        <i class="la la-ellipsis-h"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a @click.prevent.stop="editItem" href="#" class="dropdown-item" title="Edit details" v-if="fullProductManagementAccess">
                            <i class="la la-eye"></i>{{ labels.view_stock }}
                        </a>
                        <router-link :to="{ name: 'ProductForm', query: { productId: stock.productId }}" class="dropdown-item" href="#" v-if="fullProductManagementAccess">
                            <i class="la la-edit"></i> {{ labels.update_product }}
                        </router-link>
                        <a @click.prevent="deleteItem" href="#" class="dropdown-item" title="Delete" v-if="fullProductManagementAccess">
                            <i class="la la-trash"></i>{{ labels.delete_stock }}
                        </a>
                        <router-link :to="{ name: 'PreviewProduct', query: { productId: stock.productId }}" class="dropdown-item" href="#" v-if="!fullProductManagementAccess && stockAccess">
                            <i class="la la-eye"></i> {{ labels.preview_product }}
                        </router-link>
                    </div>
                </div>
            </span>
        </td>
    </tr>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { HTTP } from '../../assets/js/axiosConfig'
import SweetAlert from '../../assets/js/mixins'
import AlertAction from '../../assets/js/mixins'

const timer = 3000

export default {
    props: ['stock', 'index'],
    mixins: [SweetAlert, AlertAction],
    data () {
        return {
            expiredStyle: '',
            today: new Date()
        }
    },
    computed: {
        ...mapState({
            labels: store => store.labels,
            openedIndex: store => store.stocks.openedIndex
        }),
        ...mapGetters([
            'getName',
            'fullProductManagementAccess',
            'stockAccess'
        ]),
        statusStyle () {
            if (this.stock.status === 'expired') {
                return 'color: red;'
            } else if (this.stock.status === 'expiring_soon') {
                return 'color: orange;'
            } else {
                return 'color: inherit;'
            }
        },
        cutCode () {
            return this.stock.codeStorage ? this.stock.codeStorage.slice(0, 10) + '...' : ''
        },
        openedStatus () {
            return this.stock.isOpened ? this.labels['yes'] : this.labels['no']
        },
        loanedStatus () {
            return this.stock.isLoaned ? this.labels['loaned'] : this.labels['not_loaned']
        }
    },
    methods: {
        ...mapActions([
            'toggleTableView',
            'triggerNewSearch',
            'updateStockList'
        ]),
        editItem () {
            // Toggle edit form
            this.openedIndex === this.index ? this.toggleTableView(null) : this.toggleTableView(this.index)
        },
        deleteItem () {
            this.alertAction(this.deleteRequest, 'delete_stock_warning')
        },
        deleteRequest () {
            HTTP.delete(`api/products/${this.stock.productId}/stocks/${this.stock.objectID}`)
                .then(() => {
                    // Do something on success
                    // Alert on success
                    this.sweetAlert('success', this.labels['stock_deleted'], timer)
                    // Close the table view
                    this.toggleTableView(null)
                    // Refresh algolia results to show new data
                    this.triggerNewSearch()

                    // Update stock list
                    this.updateStockList({ index: this.index })
                })
                .catch(err => {
                    console.log(err)
                    this.sweetAlert('error', this.labels['error_deleting_stock'], timer)
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Stocks/StockRow.vue